import GetCouponsHistory from '@/services/cms/couponsHistoryService/getCouponsHistory';

export default class CouponsHistoryService {
    async getCouponsHistoryService() {
        return (new GetCouponsHistory()).handle();
    }
}
